const Generator = (maxNumber) => {
   return Math.floor(Math.random() * maxNumber); 
}

export default Generator;